export const BASE_DARK_THEME_PALETTE = {
    themeDarker: '#b3d6fc',
    themeDark: '#b3d6fc',
    themeDarkAlt: '#b3d6fc',
    themePrimary: '#69afe5',
    themeSecondary: '#2488d8',
    themeTertiary: '#0078d4',
    themeLight: '#106ebe',
    themeLighter: '#005a9e',
    themeLighterAlt: '#004578',
    headerBackground: '#0078d4',
    headerBackgroundSearch: '#106ebe',
    headerBrandText: '#fff',
    headerTextIcons: '#fff',
    headerSearchBoxBackground: 'rgba(33,33,33,0.7)',
    headerSearchBoxIcon: '#eff6fc',
    headerSearchPlaceholderText: '#eff6fc',
    headerSearchButtonBackground: '#69afe5',
    headerSearchButtonBackgroundHover: '#b3d6fc',
    headerSearchButtonIcon: '#000',
    headerSearchFilters: '#69afe5',
    headerSearchFiltersHover: '#eff6fc',
    headerButtonsBackground: '#0078d4',
    headerButtonsBackgroundHover: '#106ebe',
    headerButtonsBackgroundSearch: '#106ebe',
    headerButtonsBackgroundSearchHover: '#005a9e',
    headerBadgeBackground: '#eff6fc',
    headerBadgeText: '#fff',
    headerSearchIcon: '#fff',
    searchBoxBackground: 'rgba(33,33,33,0.7)',

    black: '#ffffff',
    blackTranslucent40: 'rgba(255, 255, 255, 0.4)',
    blackTranslucent10: 'rgba(255, 255, 255, 0.1)',
    white: '#333333',
    whiteTranslucent40: 'rgba(33, 33, 33, 0.4)',
    whiteTranslucent90: 'rgba(33, 33, 33, 0.9)',
    neutralDark: '#ffffff',
    neutralPrimary: '#ffffff',
    neutralPrimaryAlt: '#f8f8f8',
    neutralSecondary: '#f4f4f4',
    neutralTertiary: '#eaeaea',
    neutralTertiaryAlt: '#c8c8c8',
    neutralQuaternary: '#2e2e2e',
    neutralLight: '#000000',
    neutralQuaternaryAlt: '#2e2e2e',
    neutralLighter: '#212121',
    neutralLighterAlt: '#212121',
    redDark: '#e81123',
    green20: '#6bb700',
    purple: '#9c89e9',

    flaggedMessage: '#242100',
    richUserContentBackground: '#eaeaea',
    composeNeutralBackground: '#212121',
    composeNeutralLighterBackground: '#fff',
    readingPaneCardBorder: '#000000',
    readingPaneCardFocusBorder: '#d0d0d0',
};
